import { PlusOutlined } from '@ant-design/icons';
import { Tooltip, notification } from 'antd';
import axios from 'axios';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
// import { getDateWithTimezone } from '../../services';
import { READ_ONLY_ROLE } from '../../utilities/constants';
import Loader from '../Loader';
import NewUserForm from './newUserForm';
import './style.scss';
import AllUsers from './users';

const CreateUsers = () => {
	const { userDetails } = useSelector((store) => store.storeProps);
	const [isLoading, setIsLoading] = useState(false);
	const [tableData, setTableData] = useState([]);
	const [newUserForm, setNewUserForm] = useState(false);
	const [editUser, setEditUser] = useState();

	const createRole = async () => {
		try {
			await axios.post(`/api/create-role`, { role: READ_ONLY_ROLE });
		} catch (error) {
			console.error(error);
		}
	};

	// const saveAuditLog = async (data, action) => {
	// 	try {
	// 		let oldUserInfo = null;
	// 		if (action === 'update') {
	// 			oldUserInfo = {
	// 				username: editUser.username,
	// 				role: editUser.role,
	// 				buckets: editUser.buckets.split(', '),
	// 				scope: editUser.scope,
	// 			};
	// 		}

	// 		let newValues = data;
	// 		let oldValues = {};

	// 		if (action === 'update') {
	// 			newValues = {};
	// 			Object.keys(data).forEach((key) => {
	// 				let newValue = data[key];
	// 				let oldValue = oldUserInfo[key];

	// 				if (key === 'buckets') {
	// 					const newBuckets = Array.isArray(newValue) ? newValue : [];
	// 					const oldBuckets = Array.isArray(oldValue) ? oldValue : [];
	// 					if (JSON.stringify(newBuckets.sort()) !== JSON.stringify(oldBuckets.sort())) {
	// 						newValues[key] = newBuckets.join(', ');
	// 						oldValues[key] = oldBuckets.join(', ');
	// 					}
	// 				} else {
	// 					if (newValue !== undefined && newValue !== oldValue) {
	// 						newValues[key] = newValue;
	// 						oldValues[key] = oldValue;
	// 					}
	// 				}
	// 			});
	// 		}
	// 		await axios.post('/api/audit-log', {
	// 			new_values: action === 'delete' ? null : JSON.stringify(newValues),
	// 			previous_values:
	// 				action === 'delete'
	// 					? JSON.stringify(newValues)
	// 					: action === 'update'
	// 						? JSON.stringify(oldValues)
	// 						: null,
	// 			config_type: 'User Management',
	// 			action: action,
	// 			created_at: getDateWithTimezone(),
	// 			created_by: username,
	// 			'@timestamp': getDateWithTimezone(),
	// 			version: 1,
	// 		});
	// 	} catch (err) {
	// 		console.error(err);
	// 	}
	// };

	const getUsers = async (action) => {
		try {
			if (!isLoading) {
				setIsLoading(true);
			}
			const res = await axios.get(`/api/get-users`);
			if (res?.data) {
				const data = res.data;
				let users = [];
				for (let key in data) {
					if (
						key != 'kibanaro' &&
						key != 'kibanaserver' &&
						key != 'readall' &&
						key != 'snapshotrestore' &&
						key != 'logstash'
					) {
						let role = '';
						let backendRoles = data[key].backend_roles;
						if (backendRoles.length) {
							role = backendRoles[0];
						}
						const buckets = data[key]?.attributes?.buckets
							? JSON.parse(data[key].attributes.buckets)
							: [];

						users.push({
							...data[key],
							username: key,
							role,
							key: key,
							buckets: buckets.length ? buckets.join(', ') : 'All Buckets',
							scope: data[key]?.attributes?.scope || 'Global Scope',
							updatedAt: data[key]?.attributes?.updatedAt || '',
							createdAt: data[key]?.attributes?.createdAt || '',
						});
					}
				}
				let sortedUsers = [];
				if (users.length) {
					sortedUsers = users.sort((a, b) => {
						if (!a.updatedAt) return 1;
						if (!b.updatedAt) return -1;
						return new Date(b.updatedAt) - new Date(a.updatedAt);
					});
				}
				setTableData(sortedUsers);
				setIsLoading(false);
				if (newUserForm) {
					setNewUserForm(false);
				}
				if (action) {
					notification.success({
						message:
							action == 'delete'
								? 'Deleted Successfully.'
								: action == 'update'
									? 'Updated Successfully.'
									: 'Created Successfully.',
					});
				}
			}
		} catch (error) {
			setNewUserForm(false);
			setIsLoading(false);
			console.error(error);
		}
	};

	useEffect(() => {
		createRole();
		getUsers();
	}, []);

	useEffect(() => {
		if (editUser) {
			setNewUserForm(true);
		}
	}, [editUser]);

	const handleAddUser = () => {
		setNewUserForm(true);
	};

	return (
		<div className='createUserPage'>
			{isLoading && <Loader />}
			{newUserForm && (
				<NewUserForm
					tableData={tableData}
					getUsers={getUsers}
					setIsLoading={setIsLoading}
					setNewUserForm={setNewUserForm}
					editUser={editUser}
					setEditUser={setEditUser}
				/>
			)}
			{!newUserForm && (
				<div className='policyStatusWrapper'>
					<div className='createUser'>
						<Tooltip title='New User'>
							<PlusOutlined
								data-testid='createNewUser'
								className='createUserIcon'
								onClick={handleAddUser}
							/>
						</Tooltip>
					</div>
					<AllUsers
						setIsLoading={setIsLoading}
						tableData={tableData}
						getUsers={getUsers}
						setEditUser={setEditUser}
						userDetails={userDetails}
					/>
				</div>
			)}
		</div>
	);
};

export default CreateUsers;
